module.exports = __webpack_public_path__ + "media/images/icons/flags/BM-343af8ad0e6209d4546ebe4d38a1533a.svg";